import React, { useState, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { useTheme } from "@context/ThemeContext";
import AssetDrawer from "./AssetDrawer";

const MultiSelect = ({
  label,
  icon: Icon,
  options,
  selectedIds = [],
  onChange,
  previewPlacement = "right",
  // 新增：变体索引支持
  variantIndexes = [],
  onVariantChange,
  maxSelection,
  onSelectionLimit
}) => {
  const { getTheme } = useTheme();
  const theme = getTheme();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const containerRef = useRef(null);

  const selectedItems = selectedIds
    .map((id) => options.find((opt) => String(opt.id) === String(id)))
    .filter(Boolean);

  return (
    <>
      <div className="relative" ref={containerRef}>
        <div
          onClick={() => setIsDrawerOpen(true)}
          className="h-9 rounded-lg px-3 flex items-center gap-2 cursor-pointer transition-all duration-200"
          role="button"
          aria-expanded={isDrawerOpen}
          aria-haspopup="dialog"
          style={{
            backgroundColor: 'var(--color-bg-primary)',
            border: `1px solid ${isDrawerOpen ? theme.colors.accentPrimary : 'var(--color-border-primary)'}`
          }}
          onMouseEnter={(e) => { if (!isDrawerOpen) e.currentTarget.style.borderColor = 'var(--color-border-hover)'; }}
          onMouseLeave={(e) => { if (!isDrawerOpen) e.currentTarget.style.borderColor = 'var(--color-border-primary)'; }}
        >
          <Icon size={12} style={{ color: 'var(--color-text-muted)' }} />
          {selectedItems.length > 0 ? (
            <div className="flex gap-1 overflow-hidden">
              {selectedItems.map((item, index) => {
                const variantIndex = variantIndexes[index] ?? -1;
                const variantName = variantIndex >= 0 && item.variations?.[variantIndex]?.title
                  ? ` (${item.variations[variantIndex].title})`
                  : '';

                return (
                  <span
                    key={item.id}
                    className="text-2xs px-1.5 rounded flex items-center gap-1 whitespace-nowrap"
                    style={{ backgroundColor: 'var(--color-accent-light)', color: theme.colors.accentSecondary }}
                  >
                    {item.imageUrl && (
                      <img
                        src={item.imageUrl}
                        className="w-3 h-3 rounded-full object-cover"
                        alt=""
                      />
                    )}
                    {item.name}{variantName}
                  </span>
                );
              })}
            </div>
          ) : (
            <span className="text-2xs italic" style={{ color: 'var(--color-text-muted)' }}>
              选择{label}
            </span>
          )}
          <div className="ml-auto" style={{ color: 'var(--color-text-muted)' }}>
            <ChevronDown size={12} />
          </div>
        </div>
      </div>

      {/* 侧边抽屉 */}
      <AssetDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        label={label}
        icon={Icon}
        options={options}
        selectedIds={selectedIds}
        onChange={onChange}
        variantIndexes={variantIndexes}
        onVariantChange={onVariantChange}
        maxSelection={maxSelection}
        onSelectionLimit={onSelectionLimit}
      />
    </>
  );
};

export default MultiSelect;
